var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mod-success"},[_c('a-icon',{attrs:{"theme":"filled","type":"check-circle"}}),_c('p',[_vm._v("恭喜您，"+_vm._s(_vm.title)+"成功，请妥善保管个人信息！")]),_c('div',{staticClass:"action"},[_c('a-button',{attrs:{"size":"large","type":"primary"},on:{"click":_vm.onBack}},[_vm._v("返回")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }